import React from "react";
import {
  PicturePreviewContainer,
  Picture,
  ButtonsContainer,
  CameraDiscardIcon,
  OkIcon,
  DiscardIcon
} from "./PicturePreviewStyled";
import { event } from "analytics";
import PicturePreviewModal from "containers/UploadPictures/PicturesUploadRequired/Modals/PreviewModal";
import { showModal } from "redux/actions/modalActions";
import { useDispatch } from "react-redux";

const PicturesLoaded = ({
  discardPicture,
  closePreview,
  closeCamera,
  handleImage,
  src,
  payload,
  status,
  name,
  isPreviewFromCamera
}) => {
  const dispatch = useDispatch();
  const handleOpenModal = () => {
    event("open-preview_modal", "preview");
    dispatch(showModal({ type: "preview" }));
  };
  const sentAndDiscardPicture = () =>
    status !== "SENT" && discardPicture({ name });
  const handleDiscardPicture = () => {
    event("discard_picture-accept", "preview-modal");
    sentAndDiscardPicture();
    closePreview();
  };
  const savePictureFromCamera = () => {
    event("save-from-camera", "camera-preview");
    handleImage(payload);
    closePreview();
    closeCamera();
  };
  const okPreview = () => {
    event("exit", "preview");
    closePreview();
  };
  const discardFromCamera = () => {
    event("discard-picture", "camera-preview");
    closePreview();
  };
  return (
    <PicturePreviewContainer>
      <Picture src={src} />
      <ButtonsContainer>
        {isPreviewFromCamera ? (
          <CameraDiscardIcon
            data-testid="discard-picture-taken_button"
            onClick={discardFromCamera}
          />
        ) : status !== "SENT" ? (
          <DiscardIcon
            data-testid="discard-library-picture_button"
            onClick={handleOpenModal}
          />
        ) : (
          <div />
        )}
        <OkIcon
          data-testid="ok-picture_button"
          onClick={isPreviewFromCamera ? savePictureFromCamera : okPreview}
        />
      </ButtonsContainer>
      <PicturePreviewModal handleDiscardPicture={handleDiscardPicture} />
    </PicturePreviewContainer>
  );
};

export default PicturesLoaded;
